function setFullWidthElementCSSVariables () {
  document.addEventListener('resize', setVariables)
  setVariables()
}

// Courtesy of https://stackoverflow.com/questions/986937/how-can-i-get-the-browsers-scrollbar-sizes
function getScrollBarWidth () {
  const inner = document.createElement('p')
  inner.style.width = '100%'
  inner.style.height = '200px'

  const outer = document.createElement('div')
  outer.style.position = 'absolute'
  outer.style.top = '0px'
  outer.style.left = '0px'
  outer.style.visibility = 'hidden'
  outer.style.width = '200px'
  outer.style.height = '150px'
  outer.style.overflow = 'hidden'
  outer.appendChild(inner)

  document.body.appendChild(outer)
  const w1 = inner.offsetWidth
  outer.style.overflow = 'scroll'
  let w2 = inner.offsetWidth
  if (w1 === w2) w2 = outer.clientWidth

  document.body.removeChild(outer)

  return (w1 - w2)
}

function setVariables () {
  const scrollbarWidth = getScrollBarWidth()
  document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
  document.body.style.setProperty('--viewport-width', 'calc(100vw - var(--scrollbar-width))')
  document.body.style.setProperty('--full-width-element-margin', 'calc(-50vw + var(--scrollbar-width)/2)')
}

export default setFullWidthElementCSSVariables
